<div #containerSlider class="accordion-slider-container" [class]="themeService.getTheme()">
  <div class="title-container mb-4">
    <app-texts
      [texts]="texts"
    />
    <div class="arrows-container">
      <app-arrow [right]="false" (emitClick)="turnLeft()" *ngIf="scrollCount != 0"/>
      <app-arrow [right]="true" (emitClick)="turnRight()" *ngIf="scrollCount != (cards.length - 4)"/>
    </div>
  </div>
  <div #accordionSlider class="accordion-slider">
      <div *ngFor="let tour of cards; index as i"
           class="accordion-slide"
           [style]="setWidthEl(i) + getBackground(tour.img)"
           [style.background-image]="tour.img"
           [style.margin-left]="i !== 0 ? '' : '0'"
           [style.margin-right]="i !== cards.length - 1 ? '' : '0'"
           (mouseover)="mouseOver(i)"
           (mouseleave)="mouseLeave()"
      >
        <div class="collapsed">
          <h2>
            <app-texts
              [texts]="[
                {text: tour.title}
              ]"
            />
          </h2>
        </div>
        <div class="expanded" style="width: calc(100% + 100px)">
          <h2 class="mb-2">
            <app-texts
              [texts]="[
                {text: tour.title}
              ]"
            />
          </h2>
          <p class="mb-3 fs-4 fw-light figma-text-subtitle">
            <app-texts
              [texts]="[
                {text: tour.text}
              ]"
            />
          </p>
          <app-button [height]="45" (click)="openFeedback()">
            <app-texts
              [texts]="[
                {text: ['Связаться', 'Contact us']}
              ]"
            />
          </app-button>
        </div>
      </div>
  </div>
</div>
<app-main-busy-bee
  [cards]="cards"
  [texts]="texts"
  class="mobile-version"
/>
